import styled from '@emotion/styled';
import { BLACK, BLACK_1 } from '@/features/theme';

export const Container = styled.label(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 12px',
    borderRadius: '8px',
    backgroundColor: 'rgba(10, 11, 11, 0.05)',
    ':hover': { backgroundColor: BLACK_1 },

    svg: { flexShrink: 0 },
  };
});

export const Select = styled.select(() => {
  return {
    display: 'block',
    padding: '4px 0',
    margin: 0,
    backgroundColor: 'transparent',
    border: 'none',
    color: BLACK,
    boxShadow: 'none',
    '-moz-appearance': 'none',
    '-webkit-appearance': 'none',
    appearance: 'none',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    '::-ms-expand': { display: 'none' },
    ':focus': { outline: 'none' },
    ':focus-visible': { outline: 'none' },
  };
});
